import React from 'react';
import { Button, Text, VStack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { Page } from '../types';
import { useTranslation } from 'react-i18next';

const Page404: Page = ({ children }) => {
  const { t } = useTranslation();
  return (
    <VStack
      justify="center"
      align="center"
      w="full"
      h="100vh"
      gap={6}
      spacing={0}
    >
      {children ? (
        children
      ) : (
        <>
          <Text as="h1" textStyle="h1">
            404
          </Text>
          <Text as="h2" textStyle="h2">
            OOPS
          </Text>
          <Text
            as="h4"
            textStyle="h4"
            style={{ maxWidth: '600px', textAlign: 'center' }}
          >
            {t('notFoundPage.youGotLost')}
          </Text>
          <Button as={Link} to={'/'} colorScheme="tomato">
            {t('notFoundPage.backToSafety')}
          </Button>
        </>
      )}
    </VStack>
  );
};

Page404.getRoute = () => '/not-found/';

export default Page404;
